export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/modules/Dashboard'),
    meta: {
      requiresAuth:true,
      layout: 'app',
      breadcrumb: [
        { text: 'Dashboard' }
      ]
    }
  }, 
  {
    path: '/telescope',
    name: 'telescope',
    component: () => import('@/views/modules/Telescope'),
    meta: {
      layout: 'app'
    }
  }, 
  {
    path: '/horizon',
    name: 'horizon',
    component: () => import('@/views/modules/Horizon'),
    meta: {
      layout: 'app'
    }
  }, 
  {
    path: '/support',
    name: 'support',
    component: () => import('@/views/Support'),
    meta: {
      layout: 'base'
    }
  }, 
  {
    path: '/user-guide',
    name: 'user-guide',
    component: () => import('@/views/UserGuide'),
    meta: {
      layout: 'base'
    }
  }, 
  {
    path: '*',
    name: '404',
    component: () => import('@/views/Error'),
    meta: {
      layout: 'base'
    }
  }
]